import { render, staticRenderFns } from "./Ch1_2.vue?vue&type=template&id=3a266558&"
import script from "./Ch1_2.vue?vue&type=script&lang=js&"
export * from "./Ch1_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports